// src/services/api.js

import axios from 'axios';

console.log('[API] Initializing axios instance...');

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log(`[API] Axios instance created with baseURL: ${api.defaults.baseURL}`);

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    console.log(`[API Request] Preparing request to: ${config.baseURL}${config.url}`);
    console.log(`[API Request] Method: ${config.method?.toUpperCase()}`);
    
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('[API Request] Auth token found. Authorization header added.');
    } else {
      console.warn('[API Request] No auth token found.');
    }

    console.log('[API Request] Full Config:', {
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
      headers: config.headers,
      params: config.params,
      data: config.data,
    });

    return config;
  },
  (error) => {
    console.error('[API Request] Error in request interceptor:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`[API Response] Response received from: ${response.config.baseURL}${response.config.url}`);
    console.log('[API Response] Status:', response.status);
    console.log('[API Response] Headers:', response.headers);
    console.log('[API Response] Data:', response.data);
    return response;
  },
  (error) => {
    if (error.response) {
      // Server responded with a status other than 2xx
      console.error(`[API Response] Error response from: ${error.config?.baseURL}${error.config?.url}`);
      console.error('[API Response] Status:', error.response.status);
      console.error('[API Response] Headers:', error.response.headers);
      console.error('[API Response] Data:', error.response.data);
    } else {
      // No response from server
      console.error(`[API Response] Network error during request to: ${error.config?.baseURL}${error.config?.url}`);
      console.error('[API Response] Message:', error.message);
    }

    return Promise.reject(error);
  }
);

console.log('[API] Axios interceptors configured.');

export default api;
